import { createFileRoute, Outlet } from "@tanstack/react-router";

import { HotelFiltersProvider } from "@/features/hotels/contexts/HotelFiltersContext";
import { HotelSearchDataProvider } from "@/features/hotels/contexts/HotelSearchDataContext";
import { HotelSortProvider } from "@/features/hotels/contexts/HotelSortContext";

export const Route = createFileRoute("/_authenticated/hotels")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <HotelSearchDataProvider>
      <HotelFiltersProvider>
        <HotelSortProvider>
          <Outlet />
        </HotelSortProvider>
      </HotelFiltersProvider>
    </HotelSearchDataProvider>
  );
}
